import MenuItem from './MenuItem';
import '../../../../../../utils/i18n'

export default MenuItem;
